module.exports = __webpack_public_path__ + "img/s2_stepimg01-s.66c18292.png";